// import React, { useState } from "react";
// import { Box, Button, Avatar, Menu, MenuItem, Divider } from "@mui/material";
// import { useUI } from "../../../contexts/UIContext";
// import ThreadHistory from "./ThreadHistory";
// import UserProfile from "./UserProfile";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../../contexts/AuthContext";
// import { useWorkspace } from "../../../contexts/WorkspaceContext";
// import black_logo from "../../../assets/modalX_transparent_orange_icon.png";
// import white_logo from "../../../assets/modalX_robot_icon_white.png";
// import { button_bg_color_for_New_Project, darkTheme_bg_color } from "../../../constants/colors";
// import LightModeIcon from '@mui/icons-material/LightMode';
// import DarkModeIcon from '@mui/icons-material/DarkMode';
// import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
// import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
// import plusIcon from "../../../assets/plusIcon_for_new_project.png";

// const SidebarContent = () => {
//   const { toggleTheme, currentTheme } = useUI();
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [showProfileModal, setShowProfileModal] = useState(false);
//   const { logout } = useAuth();
//   const { clearThread, setThreadId, setThreadFiles, setHistoryFiles } = useWorkspace();
//   const isLoggedIn = localStorage.getItem('isLoggedIn');
//   const userEmail = localStorage.getItem('userEmail');
//   const theme = localStorage.getItem('theme');

//   const navigate = useNavigate();

//   const handleLogout = async () => {
//     await logout();
//     localStorage.setItem("isLoggedIn", "");
//     localStorage.setItem('token', '');
//     localStorage.removeItem('userEmail');
//     localStorage.removeItem('current_thread_id');
//     localStorage.removeItem('current_history_id');
//     navigate("/");
//   };

//   const handleNewChat = () => {
//     clearThread();
//     setThreadFiles([]);
//     setHistoryFiles([]);
//     localStorage.removeItem('current_thread_id');
//     localStorage.removeItem('current_history_id');
//     setThreadId(null);
//   };

//   const handleMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   return (
//     <Box
//       sx={{
//         width:'282px',
//         overflowY: "auto",
//         height:'100vh',
//         display: "flex",
//         flexDirection: "column",
//         p: 2,
//         bgcolor: theme === "dark" ? darkTheme_bg_color : "grey.300",
//         color: theme === "dark" ? "white" : "black"
//       }}
//     >
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
//         <Button
//           variant="outlined"
//           onClick={handleNewChat}
//           disabled={!isLoggedIn}
//           sx={{ gap:'8px',padding:'10px 24px 10px 16px',fontSize: '16px', width: '242px',textTransform:'none',bgcolor:button_bg_color_for_New_Project,color:'black',fontWeight:'600',height:'40px','&:hover': {
//             bgcolor: '#ffd9aa'
//           }}}
//         >
//           <img src={plusIcon}/>
//           New Project
//         </Button>
//         {/* <Button sx={{ bgcolor: 'transparent', border: 'none', mr: 2 }} onClick={() => navigate("/")}>
//           <Avatar src={theme === 'dark' ? black_logo : white_logo} sx={{ width: 25, height: 25, transform: theme === 'dark' ? 'scale(1.5)' : 'none' }} />
//         </Button> */}
//       </Box>
//       <div style={{marginTop:'36px'}}>
//         <ThreadHistory />
//       </div>

//       {/* <Button
//         variant="outlined"
//         onClick={handleMenuOpen}
//         sx={{ mt: 3, textTransform: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'left' }}
//       >
//         <i className="bi bi-person-circle" />
//         {userEmail}
//       </Button> */}
//       {/* <Menu
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleMenuClose}
//       >
//         <MenuItem onClick={() => { toggleTheme(); handleMenuClose(); }}>
//           {currentTheme === "dark" ? "Light mode ☀️" : "Dark mode🌙"}
//         </MenuItem>
//         <Divider />
//         <MenuItem onClick={handleLogout}>Logout</MenuItem>
//       </Menu> */}
//       <hr></hr>
//       <div style={{ width: '100%', height: '140px',justifyContent:'center'}}>
//         {/* <Button
//           onClick={() => { toggleTheme(); handleMenuClose(); }}
//           sx={{ textTransform: 'none',gap:'10px',color:theme === 'dark'?'#FFFFFF':'' }}>
//           {currentTheme === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
//           {currentTheme === "dark" ? " Light mode" : " Dark mode"}
//         </Button> */}
//         <Button sx={{ textTransform: 'none',gap:'10px',color:theme === 'dark'?'#FFFFFF':'' }}>
//           {<PersonOutlineOutlinedIcon />}
//           {userEmail}
//         </Button>
//         <Button sx={{ textTransform: 'none',gap:'10px',color:theme === 'dark'?'#FFFFFF':'' }} onClick={() => handleLogout()}>
//           {<LogoutOutlinedIcon />}
//           Log out
//         </Button>
//       </div>
//       <UserProfile
//         showModal={showProfileModal}
//         setShowModal={setShowProfileModal}
//       />
//     </Box>
//   );
// };

// export default SidebarContent;

import React, { useState } from "react";
import { Box, Button, Avatar, Typography,CardMedia } from "@mui/material";
import { useUI } from "../../../contexts/UIContext";
import ThreadHistory from "./ThreadHistory";
import UserProfile from "./UserProfile";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import { useWorkspace } from "../../../contexts/WorkspaceContext";
import black_logo from "../../../assets/modalX_transparent_orange_icon.png";
import white_logo from "../../../assets/modalX_robot_icon_white.png";
import logo from '../../../assets/upgradeLogo.png'
import {
  button_bg_color_for_New_Project,
  darkTheme_bg_color,
  hovered_chat_bg_color,
} from "../../../constants/colors";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import plusIcon from "../../../assets/plusIcon_for_new_project.png";
import {
  HoveredChat_bg_color,
  New_Project_Button_bg_color,
} from "../../../Provider/Color_Provider";
import { trackButtonEvent } from "../../../config/analytics";
import { useCreditRecharge } from "../../../contexts/CreditRechageContext";
// import deleteIcon from '../../../assets/DeleteIcon.png'
import deleteIcon from '../../../assets/DeleteIcon.png'


const SidebarContent = () => {
  const { toggleTheme, currentTheme } = useUI();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const { logout ,toggleLogout, setToggleLogout,allDelete, setAllDelete} = useAuth();
  const { clearThread, setThreadId, setThreadFiles, setHistoryFiles } =
    useWorkspace();
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const userEmail = localStorage.getItem("userEmail");
  const theme = localStorage.getItem("theme");
  const {upgradePlan} = useCreditRecharge()
  
  const navigate = useNavigate();

  // const handleLogout = async () => {
  //   await logout();
  //   localStorage.setItem("isLoggedIn", "");
  //   localStorage.setItem("token", "");
  //   localStorage.removeItem("userEmail");
  //   localStorage.removeItem("current_thread_id");
  //   localStorage.removeItem("current_history_id");
  //   trackButtonEvent("button_click_logout", {
  //     button_name: "Logout",
  //     button_position: "bottom-left",
  //   });
  //   navigate("/");
  // };

  const AlldeleteFunc = () =>{
    setAllDelete(true)

  }

  const handleNewChat = () => {
    clearThread();
    setThreadFiles([]);
    setHistoryFiles([]);
    localStorage.removeItem("current_thread_id");
    localStorage.removeItem("current_history_id");
    setThreadId(null);
    trackButtonEvent("button_click_New_Project", {
      button_name: "New Project",
      button_position: "Top-left",
    });
  };
  const handleToggle = () =>{
    setToggleLogout(true)
    
  }
  
  return (
    <Box
      sx={{
        width: "282px",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        p: 2,
        bgcolor: theme === "dark" ? darkTheme_bg_color : "grey.300",
        color: theme === "dark" ? "white" : "black",
      }}
    >
      <Box sx={{ mb: 2, margin: "0 auto" }}>
        <Button
          variant="outlined"
          onClick={handleNewChat}
          disabled={!isLoggedIn}
          sx={{
            gap: "8px",
            padding: "10px 24px 10px 16px",
            fontSize: "16px",
            width: "242px",
            textTransform: "none",
            // bgcolor: New_Project_Button_bg_color,
            bgcolor : '#F6BE6B',            
            color: "black",
            fontWeight: "600",
            height: "40px",
            fontFamily: "Inter, sans-serif",
            "&:hover": {
              bgcolor: "#ffd9aa",
            },
          }}
        >
          <img src={plusIcon} alt="plus icon" />
          New Project
        </Button>
      </Box>

      <Box sx={{ flexGrow: 1, overflowY: "auto", mt: 3 }}>
        <ThreadHistory />
      </Box>

      {/* Model Pro Section */}
      {/* 
      <Box sx={{
          width: '242px',
          height: '36px',
          position: 'absolute', // To use top and left properties
          top: '420px',
          left: '20px',
          border : '1px solid rgba(255, 255, 255, 0.05)',
          gap : '12px',
          borderRadius : '8px'
  
      }}>
        
      </Box> */}

      <Box
        sx={{
          mt: 3,
          pt: 3,
          borderTop: `1px solid ${theme === "dark" ? "#343a40" : "black"}`,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          justifyContent: "flex-start",
        }}
      >
        <Button onClick={upgradePlan}
          sx={{
            maxWidth: "100%",
            height: "52px",
            borderRadius: "8px",
            border: "1px solid rgba(255, 255, 255, 0.05)",
            display: "flex",
            justifyContent: "space-around",
            textTransform: "none",
            "&:hover": {
              bgcolor : '#171A2D' 
            },
            // "&:active": {
            //   bgcolor: '#171A2D', // Background color on click/active
            // },
            
          }}
        >
          <Box
            sx={{
              width: "24px",
              height: "24px",
              // bgcolor: "red",
            }}
          >
            <CardMedia
              component="img"
              sx={{
                width : '100%',
                height : '100%'
              }}
              image={logo}
              alt="logo"
            />
          </Box>
          <Box
            sx={{
              width: "182px",
              height: "40px",
              // bgcolor : 'red'
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "20px",
                letterSpacing: "0.1px",
                textAlign: "left",
                color: "#FFFFFF",
              }}
            >
              Upgrade Plan
            </Typography>

            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: 400,
                lineHeight: "20px",
                letterSpacing: "0.1px",
                textAlign: "left",
                color: "#FFFFFF",
                opacity: "60%",
              }}
            >
              Get unlimited outputs and more
            </Typography>
          </Box>
        </Button>
        <Button
          sx={{
            textTransform: "none",
            gap: "10px",
            color: theme === "dark" ? "#FFFFFF" : "black",
            justifyContent: "flex-start",
            "&:hover": { bgcolor: HoveredChat_bg_color },
          }}
        >
          <PersonOutlineOutlinedIcon />
          {userEmail}
        </Button>
        <Button
        onClick={AlldeleteFunc}
         sx={{
          width : '242px',
          height : '48px',
          display : "flex",
          justifyContent : 'space-around',
          textTransform : 'none',
          "&:hover": { bgcolor: HoveredChat_bg_color },
          
        }}>
          <Box sx={{
                width : '16px',
                height : '16px',
                marginLeft : '-6px'
               
          }}>
      <CardMedia
        component="img"
        alt="Image description"
        
        image={deleteIcon}
      />

          </Box>
          <Box sx={{
                width : '182px',
                height : '20px',
                
                
          }}>
            <Typography sx={{
              fontFamily : 'Inter',
              fontSize : '14px',
              fontWeight : 400,
              lineHeight : '20px',
              textAlign : 'left',
              color : '#FFFFFF'
            }}>Delete all projects</Typography>

          </Box>

        </Button>
        <Button
          sx={{
            textTransform: "none",
            gap: "10px",
            color: theme === "dark" ? "#FFFFFF" : "black",
            justifyContent: "flex-start",
            "&:hover": { bgcolor: HoveredChat_bg_color },
          }}
          onClick={handleToggle}
        >
          <LogoutOutlinedIcon />
          Log out
        </Button>
      </Box>

      {/* <UserProfile
        showModal={showProfileModal}
        setShowModal={setShowProfileModal}
      /> */}
    </Box>
  );
};

export default SidebarContent;
